import queryClient from "../../../../config/queryClient";

export const updateSingleDealCache = (id, dealData) => {
  // console.log("Updating deal cache", id, dealData);

  queryClient.setQueryData(["deal", id], (oldData) => ({
    ...oldData,
    ...dealData,
  }));
};

export const updateDealsListCache = ({
  id,
  updatedData,
  page,
  limit,
  queryString = "",
  queryParams = "",
  companyId,
}) => {
  // console.log(
  //   "Updating leads list cache",
  //   id,
  //   updatedData,
  //   page,
  //   limit,
  //   companyId
  // );

  queryClient.setQueryData(
    [
      "deals",
      page,
      limit,
      queryString,
      queryParams,
      companyId,
      "-leadToDealOn",
    ],
    (oldData) => {
      if (!oldData) return oldData;
      return {
        ...oldData,
        data: {
          ...oldData.data,
          data: oldData.data.data.map((deal) =>
            deal._id === id ? { ...deal, ...updatedData } : deal
          ),
        },
      };
    }
  );
  // queryClient.invalidateQueries(["deals"]);
};
